import { render, staticRenderFns } from "./MealPlannerW.vue?vue&type=template&id=e4a71504&"
import script from "./MealPlannerW.vue?vue&type=script&lang=js&"
export * from "./MealPlannerW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports